<template>
  <v-container class="top-spacer" style="padding:0">
    <div class="component-title">Bigómetro</div>
    <v-row style="overflow: auto;">
      <v-col cols="12" v-if="!isPremium">
        <PremiumContent></PremiumContent>
      </v-col>
      <v-col cols="12" v-else>
        <v-row>
          <v-col class="bigometro-col">
            <div class="card-label">Dados Gerais</div>
            <BigometroCard :key="'card-' + bankVersion"></BigometroCard>
          </v-col>
          <v-col class="dashboard-col">
            <div class="card-label">Controlo mensal</div>
            <BigometroTable :key="'table-' + bankVersion"></BigometroTable>
          </v-col>
        </v-row>
        <!-- Prognósticos -->
        <PrognosticList @update-bank="updateBank()" :label="'Prognósticos Bigometro'" :isComponent="true"></PrognosticList>
      </v-col>
    </v-row>
  </v-container>
</template>


<style scoped>
.bigometro-col {
  flex: 0 0 50%;
  max-width: 50%;
}
@media only screen and (max-width: 1112px) {
  .bigometro-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
}
</style>

<script>
import BigometroCard from "@/components/BigometroCard.vue";
import BigometroTable from "@/components/BigometroTable.vue";
import PrognosticList from "@/components/PrognosticList.vue";
import PremiumContent from "../components/PremiumContent.vue";

export default {
  name: "Bigometro",
  components: {
    BigometroCard,
    BigometroTable,
    PrognosticList,
    PremiumContent
  },
  data: () => ({
    tipoPrognostico: ["Tipo", "Simples", "Múltiplo"],
    estadoPrognostico: [""],
    bankVersion: 0
  }),
  methods: {
    updateBank() {
      this.bankVersion += 1;
    }
  },
  computed: {
    isPremium() {
      return this.$store.state.premium;
    }
  },
};
</script>
